import { PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { message, Space } from 'antd';

import { Button } from '../../../../components/index';
import { useChangePagination } from '../../../../hooks';
import { useLazyExportRegistersQuery } from '../../../../services/exportApi';
import { TerminalType } from '../../../../types';
import { PanelHeader } from '../panelHeader';
import { RegistersDrawer } from '../registersDrawer';
import { RegistersTable } from '../registersTable';
import { columns } from './columns';
import { useGetTerminalsQuery } from '../../../../services/terminalApi';
import { TerminalForm } from './TerminalForm';

export function Terminal() {
  const [searchQueryTerm, setSearchQueryTerm] = useState('');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [selectedTerminal, setselectedTerminal] = useState<TerminalType | null>(
    null
  );
  const { onChangePagination, queryPage, setQueryPage } = useChangePagination();
  const [queryPageSize, setQueryPageSize] = useState(10);

  const {
    data: terminalsData,
    isFetching: isFetchingTerminalData,
    refetch: refetchTerminalData,
  } = useGetTerminalsQuery({
    complete_filter: searchQueryTerm,
    page: onChangePagination(),
    page_size: queryPageSize,
  });

  function onSaveTerminal() {
    setselectedTerminal(null);
    refetchTerminalData();
  }
  function onCloseDrawer() {
    setIsFormVisible(false);
    setselectedTerminal(null);
  }

  function onSelectTerminal(terminal: TerminalType) {
    setselectedTerminal({
      ...terminal,
    });
    setIsFormVisible(true);
  }

  const [exportRegisters, { isLoading: isExporting }] =
    useLazyExportRegistersQuery();

  async function handleExport() {
    try {
      await exportRegisters({
        exportType: 'terminals',
        params: { search: searchQueryTerm },
      }).unwrap();
      message.success(
        'Exportação em processamento. Você a receberá em seu e-mail em breve.',
        5
      );
    } catch (error) {
      message.error('Erro ao solicitar a exportação. Tente novamente.');
    }
  }

  function actionButtons() {
    return (
      <Space size={18}>
        <Button
          icon={<DownloadOutlined />}
          size="large"
          onClick={handleExport}
          loading={isExporting}
        >
          Exportar XLS
        </Button>
        <Button
          icon={<PlusOutlined />}
          type="primary"
          size="large"
          onClick={() => setIsFormVisible(true)}
        >
          Novo Terminal
        </Button>
      </Space>
    );
  }
  function searchData(value: any) {
    setQueryPage(1);
    setSearchQueryTerm(value);
  }

  function onShowSizeChange(current: number, size: number) {
    setQueryPageSize(size);
  }

  return (
    <>
      <RegistersDrawer visible={isFormVisible} width={640}>
        <TerminalForm
          name="terminal"
          onClose={onCloseDrawer}
          selectedTerminal={selectedTerminal}
          onSaveTerminal={onSaveTerminal}
          setQueryPage={setQueryPage}
        />
      </RegistersDrawer>
      <PanelHeader
        panelName="terminal"
        actionButtons={actionButtons()}
        onSearch={searchData}
      />
      <RegistersTable
        rowKey="id"
        queryPage={queryPage}
        columns={columns}
        total={terminalsData?.count}
        dataSource={terminalsData?.results || []}
        onChangePagination={onChangePagination}
        isLoading={isFetchingTerminalData}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onSelectItem={onSelectTerminal}
      />
    </>
  );
}
